var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.getters['authorization/acl'].hasPermission('campaigns_access'))?_c('div',{staticClass:"PlatformCampaignsView"},[_c('ShPageHeader',{attrs:{"title":"Kampanie","description":"Poniżej znajduje się lista wszystkich kampanii klienta.<br>","breadcrumb-items":[
                  { label: 'zarządzanie' },
                  { label: 'Kampanie', path: '/campaigns' }
                ]}}),_c('ShPageLayout',[_c('CampaignsList')],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }